/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect } from 'react';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import IconBack from '../../../assets/Images/icons/icon-back';
import { Button, Form, Input, Table, Tooltip } from 'antd';
import { SearchOutlined, FormOutlined } from '@ant-design/icons';
import IconNotFound from '../../../assets/Images/icons/empty';
import ModalAddDomain from './components/ModalAddDomain';
import ModalFail from '../../../components/Shared/modal/fail';
import IconAddDomainFail from '../../../assets/Images/icons/icon-add-domain-fail';
import MyCompanyService from '../../../services/MyCompany.service';
import useNotify from '../../../context/Notification/useNotify';
import UserService from '../../../services/UserService';
import ModalDelete from '../../../components/Shared/modal/delete';
import { ROUTER } from '../../../constants/router';
import DeleteIcon from '../../../assets/Images/icons/delete-icon';

export default function DomainList() {
    const { t, i18n } = useTranslation();
    const lang = i18n.language;
    const Navigate = useNavigate();
    const location = useLocation();
    const { app } = location?.state;
    const { id } = useParams();
    const notify = useNotify();

    const [modalMode, setModalMode] = useState('');

    const [domainId, setDomainId] = useState();
    const [domainAddMode, setDomainMode] = useState(true);
    const [openAddDomain, setOpenAddDomain] = useState(false);
    const [openModalFail, setOpenModalFail] = useState(false);
    // ConfirmDelete
    const [openConfirmDelete, setOpenConfirmDelete] = useState(false);
    const [domain, setDomain] = useState('');
    const [currentPage, setCurrentPage] = useState({
        page: 1,
        pageSize: 10,
        sortBy: 'domainName',
        sortDirection: 'ASC',
        total: 0,
    });
    const [searchValue, setSearchValue] = useState({
        domainName: '',
    });
    const [responseData, setResponseData] = useState([]);
    const [domainTotal, setDomainTotal] = useState();

    const columns = [
        {
            title: 'No.',
            width: 30,
            // dataIndex: 'domainNo',
            // key: 'domainNo',
            sorter: () => null,
            render: (row, record, text) => {
                const numPage = currentPage.page - 1;
                const number = text + 1;
                const sum = numPage * 10;
                return <div>{number + sum}</div>;
            },
        },
        {
            title: t('Domain'),
            dataIndex: 'domainName',
            key: 'domainName',
            sorter: () => null,
        },
        // {
        //     title: t('MyCompany.Page'),
        //     dataIndex: 'pages',
        //     key: 'pages',
        //     width: 200,
        //     sorter: () => null,
        // },
        // {
        //     title: t('MyCompany.User'),
        //     dataIndex: 'users',
        //     key: 'users',
        //     width: 200,
        //     sorter: () => null,
        // },
        {
            title: t('Action'),
            key: 'action',
            align: 'center',
            width: 200,
            render: (text, record) => (
                <span style={{ whiteSpace: 'nowrap' }}>
                    <Tooltip
                        placement="bottom"
                        title="Edit"
                        className="cursor-pointer hover:opacity-80"
                    >
                        <span
                            style={{
                                backgroundColor: '#F3F6F9',
                                borderRadius: 6,
                                width: 30,
                                height: 30,
                                padding: '4px 7px',
                                textAlign: 'center',
                                marginLeft: 5,
                                color: '#7B67FB',
                            }}
                            onClick={() => {
                                setOpenAddDomain(true);
                                setDomainId(record.domainId);
                                setDomain({
                                    companyId: id,
                                    domainId: record.domainId,
                                    domainName: record.domainName,
                                });
                            }}
                        >
                            <FormOutlined />
                        </span>
                    </Tooltip>
                    {record.users > 0 ? (
                        <span className="cursor-not-allowed hover:opacity-80 absolute top-[0.6rem] p-1">
                            <DeleteIcon disabled />
                        </span>
                    ) : (
                        <Tooltip
                            placement="bottom"
                            title="Delete"
                            className="cursor-pointer hover:opacity-80 absolute top-[0.6rem] p-1"
                        >
                            <span
                                style={{
                                    height: 30,
                                }}
                                onClick={async () => {
                                    try {
                                        const { data } =
                                            await MyCompanyService.checkDomainUsage(
                                                record?.domainId
                                            );
                                        const item = data?.resultData;
                                        console.log(item);
                                        if (item?.domainIsUsage === true) {
                                            notify({
                                                type: 'error',
                                                title: t(
                                                    'Fail to delete domain'
                                                ),
                                                description: t(
                                                    'This domain is connected to data subject request'
                                                ),
                                                timeOut: 1200000,
                                                closeable: true,
                                            });
                                        } else {
                                            setDomain({
                                                id: record?.domainId,
                                                name: record?.domainName,
                                            });
                                            setOpenConfirmDelete(true);
                                        }
                                    } catch (err) {
                                        console.log(err);
                                        notify({
                                            type: 'error',
                                            title: t('Fail to delete domain'),
                                            description: t(
                                                'A server error has occurred'
                                            ),
                                            timeOut: 1200000,
                                            closeable: true,
                                        });
                                    }
                                }}
                            >
                                <DeleteIcon />
                            </span>
                        </Tooltip>
                    )}
                </span>
            ),
        },
    ];

    const [seachFlag, setSeachFlag] = useState(false);

    const paginationProps = {
        current: parseInt(currentPage.page),
        // pageSize: 10,
        total: parseInt(currentPage.total),
        // showQuickJumper: true,
        showSizeChanger: true,
        showTotal: (total, range) => ` ${range[0]}-${range[1]} of ${total} `,
    };

    const onPageChange = async (pagination, filters, sorter) => {
        // history.push(`${ROUTE.CHARGER_MANAGEMENT}/${pagination.current}`);
        const pageValues = {
            page: pagination.current,
            pageSize: pagination.pageSize,
            sortBy: sorter && sorter.order ? sorter.columnKey : 'domainName',
            sortDirection:
                sorter && sorter.order
                    ? sorter.order.substring(0, 3).toUpperCase() === 'ASC'
                        ? 'asc'
                        : 'desc'
                    : 'asc',

            //   total: pageValue.total,
            total: currentPage.total,
        };
        setCurrentPage(pageValues);
        getDomainList(searchValue, pageValues);
    };

    const getDomainList = async (payload, pageValue) => {
        let ObjectSearch = {};
        ObjectSearch = {
            companyId: id,
            domainName: payload.domainName.domainName,
            p: seachFlag ? 1 : pageValue?.page,
            ps: pageValue?.pageSize ? pageValue.pageSize : 10,
            s: pageValue?.sortBy ? pageValue?.sortBy : 'domainName',
            sd: pageValue?.sortDirection || 'ASC',
        };
        try {
            const { data } = await MyCompanyService.getDomainList(ObjectSearch);
            const item = data?.resultData;
            setResponseData(data?.resultData?.result || []);
            setDomainTotal(data?.resultData?.domainTotal)
            setCurrentPage({
                page: data?.resultData.page,
                pageSize: data?.resultData.pageSize,
                total: data?.resultData.domainTotal,
            });
            setModalMode('');
            if (item?.unLimited === true) {
                setDomainMode(true);
            } else {
                if (item?.domainTotal >= 5) {
                    setDomainMode(false);
                } else {
                    setDomainMode(true);
                }
            }
            setSeachFlag(false);
        } catch (err) {
            setCurrentPage({
                page: currentPage.page,
                pageSize: 10,
                total: 0,
            });
            console.log(err);
        }
    };

    useEffect(() => {
        getDomainList(searchValue, currentPage);
    }, [
        searchValue,
        currentPage.page,
        currentPage.pageSize,
        modalMode === 'success',
    ]);

    const onFinish = (value) => {
        setSeachFlag(true);
        setSearchValue({ domainName: value });
    };

    // Role
    const role = UserService.role().toLowerCase();
    const admin = ['admin', 'auditor', 'super admin'].includes(role);

    useEffect(() => {
        if (!admin) {
            Navigate('/not-found');
        }
    }, []);
    return (
        <>
            <div className="title flex">
                <div
                    className="cursor-pointer mr-3"
                    onClick={() => {
                        Navigate(
                            ROUTER.CONFIGURATION.USER_MANAGEMENT + '/my-company'
                        );
                    }}
                >
                    <IconBack />
                </div>
                <span>{app?.companyName || '-'}</span>
            </div>
            <div className="sub-title mb-2">
                <span className="text-sm text-gray-400">
                    {t('common.Configuration')} / {t('common.UserManagement')} /{' '}
                    {t('My Company')} /{' '}
                </span>
                <span>{app?.companyName}</span>
            </div>

            <div className="my-4 space-y-4">
                <div className="w-full rounded-md bg-white p-6">
                    <div className="space-y-2">
                        <span className="text-xl font-medium">
                            {t('Search')}
                        </span>
                        <Form onFinish={onFinish}>
                            <div className="grid grid-cols-3 space-x-2">
                                <Form.Item className="" name="domainName">
                                    <Input
                                        size="large"
                                        placeholder={t('COOKIE.DomainName')}
                                    />
                                </Form.Item>
                                <div className="">
                                    <Button
                                        htmlType="submit"
                                        icon={<SearchOutlined />}
                                        size="large"
                                        type="primary"
                                    >
                                        {t('Search')}
                                    </Button>
                                </div>
                            </div>
                        </Form>
                    </div>
                </div>
                <div className="w-full rounded-md bg-white p-6 space-y-4">
                    <div className="flex space-x-2 items-center justify-between">
                        <div className="grid grid-cols-1">
                            <div className="text-xl font-[500] ">
                                {t('MyCompany.DomainList')}
                            </div>
                            <div className="text-[#B5B5C3] text-xs font-normal">
                                {t('MyCompany.SetUpAndManageDomain')}
                            </div>
                        </div>
                        <div>
                            <Button
                                onClick={() => {
                                    if (domainAddMode) {
                                        setOpenAddDomain(true);
                                    } else {
                                        setOpenModalFail(true);
                                    }
                                }}
                                size="large"
                                type="primary"
                            >
                                {t('MyCompany.AddDomain')}
                            </Button>
                        </div>
                    </div>
                    <div className="font-semibold text-xs">
                        {t('TotalItems', { length: domainTotal })}
                    </div>
                    <div>
                        <Table
                            locale={{ emptyText: <IconNotFound /> }}
                            className="inbox_table"
                            rowKey={(record) => record.id}
                            //loading={loading}
                            columns={columns}
                            dataSource={responseData}
                            pagination={paginationProps}
                            onChange={onPageChange}
                        />
                    </div>
                </div>
            </div>
            <ModalAddDomain
                setDomainId={setDomainId}
                domainId={domainId}
                setDomain={setDomain}
                domainDetail={domain}
                setModalMode={setModalMode}
                open={openAddDomain}
                handelClose={() => setOpenAddDomain(false)}
            />
            <ModalFail
                open={openModalFail}
                title={t('MyCompany.TopicFailAddDomain')}
                // "FailAddDomain": "บัญชีองค์กรได้ใช้ Domain ครบตามที่กำหนดแล้ว สามารถอัปเกรด Plan เพื่อให้สร้าง Domain เพิ่มเติ่มได้ที่ {{www}} > Contact Us"
                // "FailAddDomain": "Your organization's account has reached the domain limit. You can upgrade your plan to create more domains at {{www}} > Contact Us"
                text={
                    lang === 'en' ? (
                        <div className="text-[13px]">
                            Your organization's account has reached <br />
                            the domain limit. You can upgrade your plan <br />
                            to create more domains at <br />
                            <a
                                className="underline text-[#1890FF] hover:underline hover:text-[#1890FF] hover:opacity-80"
                                href="https://whitefact.co/"
                                target="_blank"
                                rel="noreferrer"
                            >
                                whitefact.co
                            </a>
                            <span>{' > Contact Us'} </span>
                        </div>
                    ) : (
                        <div className="text-[13px]">
                            {'บัญชีองค์กรได้ใช้ Domain ครบตามที่กำหนดแล้ว'}{' '}
                            <br />
                            {
                                'สามารถอัปเกรด Plan เพื่อให้สร้าง Domain เพิ่มเติ่มได้ที่'
                            }{' '}
                            <br />{' '}
                            <a
                                className="underline text-[#1890FF] hover:underline hover:text-[#1890FF] hover:opacity-80"
                                href="https://whitefact.co/"
                                target="_blank"
                                rel="noreferrer"
                            >
                                whitefact.co
                            </a>
                            <span>{' > Contact Us'} </span>
                        </div>
                    )
                }
                handelClose={() => setOpenModalFail(false)}
                icon={<IconAddDomainFail />}
            />
            <ModalDelete
                title={t('common.ConfirmDelete')}
                text={t('MyCompany.DoYouWantDeleteDomain', {
                    domain: domain?.name,
                })}
                open={openConfirmDelete}
                handelOk={() => {
                    setOpenConfirmDelete(false);
                    MyCompanyService.deleteDomain(domain?.id)
                        .then((res) => {
                            setOpenConfirmDelete(false);
                            notify({
                                title: t('common.Success'),
                                description: t('Successfully to delete data'),
                            });
                            getDomainList(searchValue, currentPage);
                        })
                        .catch((err) => {
                            setOpenConfirmDelete(false);
                            notify({
                                type: 'error',
                                title: t('Fail to delete domain'),
                                description: t('A server error has occurred'),
                                timeOut: 1200000,
                                closeable: true,
                            });
                        });
                }}
                handelClose={() => setOpenConfirmDelete(false)}
            />
        </>
    );
}
